export default "/images/icons8-france.png?cf8083d845144a41b3c02da24a0f9723";